import en from 'messages/en.json'
import { FC } from 'react'
// tslint:disable-next-line:import-blacklist
import { FormattedMessage } from 'react-intl'
import { Props } from 'react-intl/src/components/message'

export const MiteneFormattedMessage: FC<Props> = (props) => {
  const defaultMsgs: { [key: string]: string } = en
  const id = props.id as string
  const msg = defaultMsgs[id]
  if (!msg) {
    throw Error(`Unknown id ${props.id}`)
  }
  return (
    <FormattedMessage {...props} defaultMessage={msg} tagName='span' />
  )
}
